import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function ServicesCTA() {
  const { ref: accessRef, isVisible: accessVis } = useScrollAnimation({ threshold: 0.15 });
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  const highlights = [
    { icon: 'ri-time-line', text: 'Evening and night classes available' },
    { icon: 'ri-bank-card-line', text: 'Flexible payment options including Afterpay' },
    { icon: 'ri-group-2-line', text: 'Serving all ages, all backgrounds' },
    { icon: 'ri-shield-star-line', text: 'Discounts for military and first responders' },
  ];

  return (
    <>
      {/* Accessibility Banner */}
      <section className="py-16 bg-gradient-to-r from-[#1E3A8A]/8 via-white to-[#5B21B6]/8 border-y border-gray-100">
        <div className="max-w-screen-xl mx-auto px-8">
          <div ref={accessRef} className="flex flex-col lg:flex-row items-center justify-between gap-8">
            <div className={`scroll-hidden-tilt-left ${accessVis ? 'scroll-visible' : ''}`}>
              <p className="font-body text-brand-blue-dark text-xs uppercase tracking-widest font-semibold mb-2">Designed for Everyone</p>
              <h3 className="font-heading text-3xl font-black text-brand-blue-dark">
                Flexible, Accessible, <span className="gradient-text">Welcoming</span>
              </h3>
            </div>
            <div className="grid grid-cols-2 gap-4 flex-1 max-w-2xl">
              {highlights.map((h, i) => (
                <div
                  key={h.text}
                  className={`scroll-hidden-blur ${accessVis ? 'scroll-visible' : ''} flex items-center gap-3`}
                  style={{ transitionDelay: `${i * 120 + 150}ms` }}
                >
                  <div className={`w-9 h-9 flex items-center justify-center rounded-lg bg-brand-yellow/20 text-brand-yellow-dark flex-shrink-0 wiggle-hover`}>
                    <i className={`${h.icon} text-base`} />
                  </div>
                  <p className="font-body text-gray-600 text-sm leading-snug">{h.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section ref={ref} className="py-28 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1E3A8A] via-[#2D1B69] to-[#5B21B6]" />
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-yellow/8 rounded-full blur-3xl pointer-events-none float-slow" />

        <div className="relative z-10 max-w-screen-lg mx-auto px-8 text-center">
          <div className={`scroll-hidden-scale-blur ${isVisible ? 'scroll-visible' : ''}`}>
            <span className={`scroll-hidden-pop ${isVisible ? 'scroll-visible' : ''} inline-block px-4 py-1.5 rounded-full border border-brand-yellow/40 text-brand-yellow font-body text-xs uppercase tracking-widest bg-brand-yellow/10 mb-7`}>
              Ready to Begin?
            </span>
            <h2 className="font-heading text-6xl lg:text-7xl font-black text-white mb-6 leading-tight">
              Your Creative Journey<br />
              <span className="text-brand-yellow">Starts Here</span>
            </h2>
            <p className="font-body text-white/70 text-lg max-w-xl mx-auto leading-relaxed mb-12">
              Whether you are enrolling in a program, booking an event, or simply exploring your options, our team is ready to help you take the next step.
            </p>
            <div className="flex flex-wrap justify-center gap-5">
              <Link
                to="/contact"
                className="whitespace-nowrap btn-shimmer px-10 py-4 rounded-full bg-brand-yellow text-brand-blue-dark font-body font-bold text-base hover:bg-brand-yellow-light transition-all cursor-pointer"
              >
                Book a Free Consultation
              </Link>
              <Link
                to="/pricing-support"
                className="whitespace-nowrap px-10 py-4 rounded-full border-2 border-white/40 text-white font-body font-semibold text-base hover:border-brand-yellow hover:text-brand-yellow transition-all cursor-pointer"
              >
                View Pricing
              </Link>
            </div>
            <div className="flex flex-wrap justify-center gap-8 mt-14 pt-10 border-t border-white/10">
              <a href="tel:9102424567" className="flex items-center gap-2 font-body text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-brand-yellow text-base" />
                </div>
                910-242-4567
              </a>
              <a href="mailto:info@creativeinstitutellc.com" className="flex items-center gap-2 font-body text-white/50 text-sm hover:text-white/80 transition-colors cursor-pointer">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-brand-yellow text-base" />
                </div>
                info@creativeinstitutellc.com
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
